/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

export * from 'vs/platform/theme/common/colorUtils';

// Make sure all color files are exported
export * from 'vs/platform/theme/common/colors/baseColors';
export * from 'vs/platform/theme/common/colors/chartsColors';
export * from 'vs/platform/theme/common/colors/editorColors';
export * from 'vs/platform/theme/common/colors/inputColors';
export * from 'vs/platform/theme/common/colors/listColors';
export * from 'vs/platform/theme/common/colors/menuColors';
export * from 'vs/platform/theme/common/colors/minimapColors';
export * from 'vs/platform/theme/common/colors/miscColors';
export * from 'vs/platform/theme/common/colors/quickpickColors';
export * from 'vs/platform/theme/common/colors/searchColors';
